import { useUniversalFiltersContext } from '../UniversalFiltersProvider';

/**
 * Returns the provider-scoped universal-filter store for custom integrations.
 */
export function useUniversalFiltersStore() {
  return useUniversalFiltersContext().store;
}
